export default "__VITE_ASSET__D2A3bk3u__"